<template>
  <desktop-page v-if="smAndLarger"/>
  <mobile-page v-else/>
</template>

<script>
import { defineComponent, onMounted, provide } from '@vue/composition-api';
import DesktopPage from '@/DesktopPage';
import MobilePage from '@/MobilePage';
import useDeviceCheck from '@/compositions/useDeviceCheck';
import { useBasketProvider, useBasketContext } from '@/compositions/basket/basketStorage';
import { useLocationProvider } from '@/compositions/location/locationStorage';
import useWishListLayout from '@/compositions/layout/useWishListLayout';
import useDigitalDataManager from '@/compositions/ddm/useDigitalDataManager';

export default defineComponent({
  name: 'Cart',
  components: { MobilePage, DesktopPage },
  setup() {
    useBasketProvider();
    useLocationProvider();
    useWishListLayout();

    const { smAndLarger } = useDeviceCheck();
    const { fetchBasket } = useBasketContext();
    const digitalDataManager = useDigitalDataManager();

    provide('digitalDataManager', digitalDataManager);

    onMounted(() => {
      fetchBasket();
    });

    return {
      smAndLarger,
    };
  },
});
</script>
